import moment from 'moment';
import { isFilterActive } from '../molecules/activeFilter.styles';
import { SIMPLE_DATE_FORMAT } from '../../utils/utils';

const optionLabel = (value, intlMessages, translationPrefix) => intlMessages[`${translationPrefix}${value}`] || null;

const CHIP_DEFINITIONS = [
  {
    key: 'projectIds',
    fields: ['projectIds'],
    resolve: (filters, { projectName }) => projectName || null
  },
  {
    key: 'dateRange',
    fields: ['startDate', 'endDate'],
    resolve: filters => {
      const { startDate, endDate } = filters;

      if (!startDate || !endDate) return null;

      return `${moment(startDate).format(SIMPLE_DATE_FORMAT)} - ${moment(endDate).format(SIMPLE_DATE_FORMAT)}`;
    }
  },
  {
    key: 'published',
    fields: ['published'],
    resolve: (filters, { intlMessages, statusOptions }) => {
      const option = statusOptions.find(({ value }) => value === filters.published);

      return option ? optionLabel(option.label, intlMessages, 'project.inspection.status.') : null;
    }
  },
  {
    key: 'type',
    fields: ['type'],
    resolve: (filters, { intlMessages }) => optionLabel(filters.type, intlMessages, 'project.inspections.type.')
  },
  {
    key: 'formularyIds',
    fields: ['formularyIds'],
    resolve: (filters, { formularies }) => {
      const match = (formularies || []).find(formulary => `${formulary.id}` === `${filters.formularyIds}`);

      return (match || {}).name || null;
    }
  },
  {
    key: 'query',
    fields: ['query'],
    resolve: filters => filters.query || null
  }
];

export const buildInspectionsFilterChips = ({ filters = {}, defaults = {}, context, removeFields }) =>
  CHIP_DEFINITIONS.filter(({ fields }) => fields.some(field => isFilterActive(filters[field], defaults[field])))
    .map(({ key, fields, resolve }) => ({
      key,
      label: resolve(filters, context),
      onRemove: () => removeFields(fields)
    }))
    .filter(chip => !!chip.label);
